export const APPLICATION_STATE_KEY = 'applicationState';
